import React from 'react';
import { Pagesection, Contentheader } from '@ktag/styleguide/dist/react';
import { WebMap, WebMapStateProvider } from '@agissc/ktag-map';
import useAppState from '../AppStore';

const Entdecken = () => {
  return (
    <>
      <Pagesection>
        <Contentheader
          pagetitle="Sie möchten mehr über einen bestimmten Ort erfahren?"
          leadtext="Leadtext ipsum dolor sit amet, consectetur adipiscing elit. Etiam urna nulla, pharetra sed turpis vel."
        />
        <div
          style={{
            width: '500px',
            height: '500px',
            position: 'relative',
            margin: 'auto',
          }}
        >
          <WebMapStateProvider useLocalState={useAppState}>
            <WebMap />
          </WebMapStateProvider>
        </div>
      </Pagesection>
      <Pagesection type="slender">
        <div className="richtext">
          <p>
            Regularily, content is placed inside a slender section. Imperdiet viverra
            purus. Curabitur feugiat elit sit amet lobortis vulputate. Vestibulum laoreet
            commodo fringilla. Nulla eu quam ac quam vulputate venenatis. Praesent metus
            nunc, condimentum quis vehicula vitae, venenatis vitae nisl. Etiam sed
            sagittis lacus. Pellentesque habitant morbi tristique senectus et netus et
            malesuada fames ac turpis egestas. Nunc vulputate eleifend mi, at lobortis
            sapien ultrices quis.
          </p>
        </div>
      </Pagesection>
      <Pagesection type="medium">
        <div className="richtext">
          <p>
            Regularily, content is placed inside a slender section. Imperdiet viverra
            purus. Curabitur feugiat elit sit amet lobortis vulputate. Vestibulum laoreet
            commodo fringilla. Nulla eu quam ac quam vulputate venenatis. Praesent metus
            nunc, condimentum quis vehicula vitae, venenatis vitae nisl. Etiam sed
            sagittis lacus. Pellentesque habitant morbi tristique senectus et netus et
            malesuada fames ac turpis egestas. Nunc vulputate eleifend mi, at lobortis
            sapien ultrices quis.
          </p>
          <p>
            Curabitur vitae laoreet nisl. Nunc fermentum augue mauris, id commodo odio
            maximus vel. Phasellus accumsan luctus elit ut efficitur. Quisque vitae nisi
            eget mauris placerat hendrerit vel nec ipsum. Aenean auctor suscipit arcu, id
            volutpat eros pharetra vitae. Sed eget egestas quam. Aenean elementum arcu nec
            libero rutrum, quis congue orci consequat. Aliquam mattis ultricies lacus sit
            amet pretium.
          </p>
        </div>
      </Pagesection>
    </>
  );
};

export default Entdecken;
